var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-3"},[_c('b-card',{attrs:{"header":"Notifications"}},[_c('notifications-widget',{attrs:{"all":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }